import { Component, AfterViewInit, Output, EventEmitter, DoCheck } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { OwnerService } from '../../../service/owner/owner.service';
import { PrefService } from '../../../service/pref/pref.service';
import { SalesofficeService } from '../../../service/salesoffice/salesoffice.service';
import { WhService } from '../../../service/wh/wh.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { validation } from '../../../util/validation';

@Component({
  selector: 'wa9192',
  templateUrl: './wa9192.component.html',
  styleUrls: ['./wa9192.component.scss']
})
export class Wa9192Component implements AfterViewInit, DoCheck {
  public componentTitle = 'WA9192:荷主マスタ登録';

  // public ownerId: FormControl;
  public ownerCd: FormControl;
  public ownerTx: FormControl;
  public ownerfullname1Tx: FormControl;
  public ownerfullname2Tx: FormControl;
  public owneraccCd: FormControl;
  public ownerpostalCd: FormControl;
  public owneraddress1Tx: FormControl;
  public owneraddress2Tx: FormControl;
  public owneraddress3Tx: FormControl;
  public ownertelTx: FormControl;
  public yamatobasenoCd: FormControl;
  public validation = validation;
  public bookendNr = 0;
  public invstockfreqNr = 0;
  // public delimemodelidateNr = 0;
  // public delimemomemodetNr = 0;
  // public delimemoordernoNr = 0;
  // public delimemoitemNr = 0;
  // public delidateFl = 0;
  // public itemnameFl = 0;
  // public memodetFl = 0;
  // public memodetinveFl = 0;
  // public delipriceFl = false;

  public owners: any;
  public prefs: any;
  public salesoffices: any;
  public whs: any;

  public ownerId: number;
  // public prefTx: string;
  public salesofficeId: number = 0;
  public whCd: string = '';
  public bookends: any;

  public working = false;
  public working2 = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  public rootFormGroup: FormGroup;
  public dump = '';
  private errorInfo = '';

  private openotherwindow: boolean = false;
  @Output() onSubmitClick = new EventEmitter();

  private isDelayHide = true;
  constructor(
    private router: Router,
    private ownerService: OwnerService,
    private prefService: PrefService,
    private salesofficeService: SalesofficeService,
    private whService: WhService,
    private commonService: CommonService,
    private dialogsService: DialogsService,
    private formbuilder: FormBuilder
  ) {
    sessionStorage.removeItem('wa9192openotherwindow');
    this.ownerCd = new FormControl('', [
      Validators.pattern(validation.halfBlankOnly),
      Validators.pattern(validation.code39),
      Validators.minLength(validation.ownerCd.minLength),
      Validators.maxLength(validation.ownerCd.maxLength)
    ]);
    this.ownerTx = new FormControl('', [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.ownerTx.maxLength)
    ]);
    this.ownerfullname1Tx = new FormControl('', [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.ownerfullname1Tx.maxLength)
    ]);
    this.ownerfullname2Tx = new FormControl('', [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.ownerfullname2Tx.maxLength)
    ]);
    this.owneraccCd = new FormControl('', [
      Validators.pattern(validation.halfBlankOnly),
      Validators.pattern(validation.code39),
      Validators.maxLength(validation.owneraccCd.maxLength)
    ]);
    this.ownerpostalCd = new FormControl('', [
      Validators.pattern(validation.halfBlankOnly),
      Validators.pattern(validation.code39),
      Validators.pattern(validation.ownerpostalCd.postcode),
      Validators.maxLength(validation.ownerpostalCd.maxLength)
    ]);
    this.owneraddress1Tx = new FormControl('', [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.owneraddress1Tx.maxLength)
    ]);
    this.owneraddress2Tx = new FormControl('', [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.owneraddress2Tx.maxLength)
    ]);
    this.owneraddress3Tx = new FormControl('', [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.owneraddress3Tx.maxLength)
    ]);
    this.ownertelTx = new FormControl('', [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.pattern(validation.ownertelTx.tel),
      Validators.maxLength(validation.ownertelTx.maxLength)
    ]);
    this.yamatobasenoCd = new FormControl('', [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.yamatobasenoCd.maxLength)
    ]);

    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    this.ownerService
      .get()
      .then(outputJson => {
        this.owners = outputJson.owners;
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.salesofficeService
      .get()
      .then(__outputJson => {
        this.salesoffices = __outputJson.salesoffices;
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.whService
      .get()
      .then(__outputJson => {
        this.whs = __outputJson.whs;
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onSubmit() {
    let errors = false;
    const ownerCd = this.ownerCd.value.trim();
    const ownerTx = this.ownerTx.value.trim();
    const ownerfullname1Tx = this.ownerfullname1Tx.value.trim();
    const ownerfullname2Tx = this.ownerfullname2Tx.value.trim();
    const owneraccCd = this.owneraccCd.value.trim();
    const ownerpostalCd = this.ownerpostalCd.value.trim();
    const owneraddress1Tx = this.owneraddress1Tx.value.trim();
    const owneraddress2Tx = this.owneraddress2Tx.value.trim();
    const owneraddress3Tx = this.owneraddress3Tx.value.trim();
    const ownertelTx = this.ownertelTx.value.trim();
    const yamatobasenoCd = this.yamatobasenoCd.value.trim();

    if (this.ownerCd.errors !== null) {
      this.ownerCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.ownerTx.errors !== null) {
      this.ownerTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.ownerfullname1Tx.errors !== null) {
      this.ownerfullname1Tx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.ownerfullname2Tx.errors !== null) {
      this.ownerfullname2Tx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.owneraccCd.errors !== null) {
      this.owneraccCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.ownerpostalCd.errors !== null) {
      this.ownerpostalCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.owneraddress1Tx.errors !== null) {
      this.owneraddress1Tx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.owneraddress2Tx.errors !== null) {
      this.owneraddress2Tx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.owneraddress3Tx.errors !== null) {
      this.owneraddress3Tx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.ownertelTx.errors !== null) {
      this.ownertelTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.yamatobasenoCd.errors !== null) {
      this.yamatobasenoCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }
    console.log(this.bookendNr)
    if (this.whCd === undefined) {
      this.errorInfo = '倉庫名を選択してください';
      return;
    }
    if (this.salesofficeId === undefined) {
      this.errorInfo = '営業所名を選択してください';
      return;
    }
    // if (this.bookendNr !== 5 && this.bookendNr !== 10 && this.bookendNr !== 15 && this.bookendNr !== 20 && this.bookendNr !== 25 && this.bookendNr !== 99) {
    //   this.errorInfo = '請求締め日が正しくありません';
    //   return;
    // }
    // if (this.invstockfreqNr !== 1 && this.invstockfreqNr !== 3) {
    //   this.errorInfo = '請求・保管期数が正しくありません';
    //   return;
    // }

    // let tmpDelipriceFl = 0;
    // if (this.delipriceFl === true) {
    //   tmpDelipriceFl = 1;
    // } else {
    //   tmpDelipriceFl = 0;
    // }
    //SW-2097　ダブルクリック抑止
    if (this.working2) return;
    this.working2 = true;
    this.ownerService
      .post(
        ownerCd,
        ownerTx,
        ownerfullname1Tx,
        ownerfullname2Tx,
        owneraccCd,
        ownerpostalCd,
        owneraddress1Tx,
        owneraddress2Tx,
        owneraddress3Tx,
        ownertelTx,
        yamatobasenoCd,
        this.whCd,
        this.salesofficeId,
        this.bookendNr,
        this.invstockfreqNr,
        0,
        'wa9192'
      )
      .then(outputJson => {
        this.cancel();
        this.onSubmitClick.emit();
        this.working2 = false;
      })
      .catch(error => {
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.working2 = false;
      });
  }

  ngDoCheck() {
    if (sessionStorage.getItem('wa9192openotherwindow') === 'open') {
      this.openotherwindow = true;
      this.isDelayHide = false;
    }

    if (!this.ownerCd.errors
      && !this.ownerTx.errors
      && !this.ownerfullname1Tx.errors
      && !this.ownerfullname2Tx.errors
      && !this.owneraccCd.errors
      && !this.ownerpostalCd.errors
      && !this.owneraddress1Tx.errors
      && !this.owneraddress2Tx.errors
      && !this.owneraddress3Tx.errors
      && !this.ownertelTx.errors
      && !this.yamatobasenoCd.errors
    ) {
      if (this.ownerCd.value !== ''
        && this.ownerTx.value !== ''
        && this.ownerfullname1Tx.value !== ''
        && this.ownerpostalCd.value !== ''
        && this.owneraddress1Tx.value !== ''
        && this.ownertelTx.value !== ''
        && this.whCd !== ''
        && this.salesofficeId !== 0
        && this.bookendNr !== 0
        && this.invstockfreqNr !== 0

      ) {
        this.working = true;
      } else {
        this.working = false;
      }
    } else {
      this.working = false;
    }
  }

  cancel() {
    sessionStorage.removeItem('wa9192openotherwindow');
    this.openotherwindow = false;
    setTimeout(() => {
      this.isDelayHide = true;
    }, 300);
    this.errorInfo = '';
    this.working = false;

    this.whCd = '';
    this.salesofficeId = 0;
    this.bookendNr = 0;
    this.invstockfreqNr = 0;

    this.ownerCd = new FormControl('', [
      Validators.pattern(validation.halfBlankOnly),
      Validators.pattern(validation.code39),
      Validators.minLength(validation.ownerCd.minLength),
      Validators.maxLength(validation.ownerCd.maxLength)
    ]);
    this.ownerTx = new FormControl('', [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.ownerTx.maxLength)
    ]);
    this.ownerfullname1Tx = new FormControl('', [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.ownerfullname1Tx.maxLength)
    ]);
    this.ownerfullname2Tx = new FormControl('', [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.ownerfullname2Tx.maxLength)
    ]);
    this.owneraccCd = new FormControl('', [
      Validators.pattern(validation.halfBlankOnly),
      Validators.pattern(validation.code39),
      Validators.maxLength(validation.owneraccCd.maxLength)
    ]);
    this.ownerpostalCd = new FormControl('', [
      Validators.pattern(validation.halfBlankOnly),
      Validators.pattern(validation.code39),
      Validators.pattern(validation.ownerpostalCd.postcode),
      Validators.maxLength(validation.ownerpostalCd.maxLength)
    ]);
    this.owneraddress1Tx = new FormControl('', [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.owneraddress1Tx.maxLength)
    ]);
    this.owneraddress2Tx = new FormControl('', [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.owneraddress2Tx.maxLength)
    ]);
    this.owneraddress3Tx = new FormControl('', [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.owneraddress3Tx.maxLength)
    ]);
    this.ownertelTx = new FormControl('', [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.pattern(validation.ownertelTx.tel),
      Validators.maxLength(validation.ownertelTx.maxLength)
    ]);
    this.yamatobasenoCd = new FormControl('', [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.yamatobasenoCd.maxLength)
    ]);
  }

  clrErr() {

    this.errorInfo = '';
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9192/wa9192.component.ts